import styled from '@emotion/styled'

export const MeterPieChartContainer = styled.div<{
    height: string
}>(({ height }) => ({
    display: 'flex',
    position: 'relative',
    height: height,
    aspectRatio: '2 / 1',
}))

export const MeterPieChartMeterWrapper = styled.div<{
    /** In radians */
    rotation: number
}>(({ rotation }) => ({
    position: 'absolute',
    bottom: 0,
    left: '48.5%',

    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    rotate: `${rotation}rad`,
    transformOrigin: '50% 95%',

    overflow: 'visible',

    transition: 'rotate 2000ms',
}))
